import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
export default class AppErrorBoundary extends React.Component {
    state = { failed: false };
    static getDerivedStateFromError() {
        return { failed: true };
    }
    componentDidCatch() {
        // Deliberately do not log the Error object: messages and stacks can contain
        // a guest/invite URL. The early bootstrap reporter records only a
        // query-free path and coarse failure phase.
        window.__reportStartupError?.("react");
        window.__markAppMounted?.();
    }
    render() {
        if (!this.state.failed)
            return this.props.children;
        return (_jsxs("main", { role: "alert", style: {
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: 24,
                boxSizing: "border-box",
                textAlign: "center",
                background: "#0a0a0f",
                color: "#fff",
            }, children: [_jsx("h1", { children: "Die Anwendung konnte nicht angezeigt werden." }), _jsx("p", { children: "The application could not be displayed. Please reload the page." }), _jsx("button", { type: "button", onClick: () => window.location.reload(), children: "Neu laden / Reload" })] }));
    }
}
